import { useEffect, useState } from "react";
import { Loader2, Plus, Trash2, Save } from "lucide-react";
import api from "../lib/apiClient";
import { toast } from "sonner";

export default function AdminCatalog() {
  const [domains, setDomains] = useState(null);
  const [ptypes, setPtypes] = useState([]);

  useEffect(() => {
    api.get("/admin/member-catalog").then((r) => { setDomains(r.data.domains); setPtypes(r.data.profile_types); }).catch(() => setDomains([]));
  }, []);

  const setD = (i, k, v) => setDomains((s) => s.map((x, j) => j === i ? { ...x, [k]: v } : x));
  const setP = (i, k, v) => setPtypes((s) => s.map((x, j) => j === i ? { ...x, [k]: v } : x));

  const save = async () => {
    try {
      const d = domains.filter((x) => x.key && x.label).map((x) => ({ key: x.key.toUpperCase().replace(/\s+/g, "_"), label: x.label }));
      const p = ptypes.filter((x) => x.key && x.label).map((x) => ({ key: x.key.toUpperCase().replace(/\s+/g, "_"), label: x.label, domain: (x.domain || "OTHER").toUpperCase(), space_label: x.space_label || "Votre parcours" }));
      const res = await api.put("/admin/member-catalog", { domains: d, profile_types: p });
      setDomains(res.data.domains); setPtypes(res.data.profile_types); toast.success("Catalogue enregistré");
    } catch (e) { toast.error(e.response?.data?.detail || "Échec"); }
  };

  if (!domains) return <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>;

  return (
    <div className="space-y-6" data-testid="admin-catalog">
      <h1 className="font-display text-3xl font-extrabold">Catalogue membre</h1>
      <p className="text-sm text-zinc-500">Gère les domaines et types de profil proposés à l'inscription.</p>

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <h2 className="font-display text-lg font-bold">Domaines</h2>
          <button onClick={() => setDomains((s) => [...s, { key: "", label: "" }])} data-testid="dom-add" className="text-sm text-amber-400 inline-flex items-center gap-1"><Plus className="w-4 h-4" />Ajouter</button>
        </div>
        {domains.map((d, i) => (
          <div key={i} className="grid sm:grid-cols-[160px_1fr_auto] gap-2 items-center" data-testid={`dom-row-${i}`}>
            <input value={d.key} onChange={(e) => setD(i, "key", e.target.value)} placeholder="CLÉ" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <input value={d.label} onChange={(e) => setD(i, "label", e.target.value)} placeholder="Libellé" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <button onClick={() => setDomains((s) => s.filter((_, j) => j !== i))} className="text-zinc-500 hover:text-red-400"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <h2 className="font-display text-lg font-bold">Types de profil</h2>
          <button onClick={() => setPtypes((s) => [...s, { key: "", label: "", domain: "OTHER", space_label: "Votre parcours" }])} data-testid="pt-add" className="text-sm text-amber-400 inline-flex items-center gap-1"><Plus className="w-4 h-4" />Ajouter</button>
        </div>
        {ptypes.map((p, i) => (
          <div key={i} className="grid sm:grid-cols-[140px_1fr_140px_1fr_auto] gap-2 items-center" data-testid={`pt-row-${i}`}>
            <input value={p.key} onChange={(e) => setP(i, "key", e.target.value)} placeholder="CLÉ" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <input value={p.label} onChange={(e) => setP(i, "label", e.target.value)} placeholder="Libellé" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <select value={p.domain} onChange={(e) => setP(i, "domain", e.target.value)} className="h-10 px-2 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-200">
              {domains.map((d) => <option key={d.key} value={d.key}>{d.key}</option>)}
            </select>
            <input value={p.space_label} onChange={(e) => setP(i, "space_label", e.target.value)} placeholder="Libellé du parcours" className="h-10 px-3 bg-zinc-900 border border-zinc-800 rounded-lg text-sm text-zinc-100" />
            <button onClick={() => setPtypes((s) => s.filter((_, j) => j !== i))} className="text-zinc-500 hover:text-red-400"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>

      <button onClick={save} data-testid="catalog-save" className="h-11 px-6 rounded-xl gold-gradient text-black font-semibold inline-flex items-center gap-2"><Save className="w-4 h-4" />Enregistrer</button>
    </div>
  );
}
